"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class MediumStyle {
    constructor() {
        this.name = types_1.FontStyleName.MEDIUM;
        this.style = graphql_schema_types_1.FontStyle.Normal;
        this.weight = 500;
    }
}
exports.default = MediumStyle;
//# sourceMappingURL=MediumStyle.js.map